import axios from 'axios';
import { camelizeKeys } from 'humps';

export const request = async ({ url, method = 'get', data, params } = {}) => {
  try {
    let timeLabel = null;
    const isServer = typeof window === 'undefined';

    if (isServer) {
      const search = new URLSearchParams(params);
      const urlLabel = search.size
        ? `${url}${url.includes('?') ? '&' : '?'}${search}`
        : url;
      timeLabel = `${new Date().getTime()}:DEBUG:request:${urlLabel}${
        data && Object.keys(data)?.length ? ` data:${JSON.stringify(data)}` : ''
      }`;
      console.time(timeLabel);
    }

    const response = await axios({
      method,
      url,
      data: !data || Object.keys(data).length === 0 ? null : data,
      params,
    });

    if (isServer) {
      console.timeEnd(timeLabel);
    }

    return camelizeKeys(response.data, (key, convert) =>
      /^[A-Z0-9_]+$/.test(key) ? key : convert(key)
    );
  } catch (error) {
    console.error('request error url: ', url);
    throw error;
  }
};

export default request;
